import { useState } from 'react';
import { DevSignInForm } from '../auth/DevSignInForm.js';
import { signInError } from '../auth/signInError.js';
import { useAuthMode } from '../auth/useSession.js';
import { usePasswordLogin } from './passwordSignIn.js';

export function TalentSignIn(): React.JSX.Element {
  const mode = useAuthMode();
  const reason = signInError('This app is for Project A and its recruiters.');
  // Recruiters sign in with outside accounts and Project A with its own; the
  // server picks whichever client it has, so one link serves both.
  const google = mode.data !== undefined && (mode.data.google || mode.data.googleAlt);

  return (
    <div className="signin">
      <div className="signin-card">
        <h1>Talent Pool</h1>
        <p className="subtle">Project A's candidate pool for the companies it backs.</p>
        {reason !== undefined && <p className="signin-error">{reason}</p>}

        {google && (
          <a className="button primary" href="/auth/google">
            Sign in with Google
          </a>
        )}
        {mode.data !== undefined && !google && !mode.data.password && (
          <p className="subtle">Google sign-in is not configured on this server yet.</p>
        )}

        {mode.data?.password === true && <PasswordSignInForm />}

        {mode.data?.devLogin === true && <DevSignInForm placeholder="you@agency.com" />}
      </div>
    </div>
  );
}

/** For recruiters outside Project A's Workspace, until a better way in replaces it. */
function PasswordSignInForm(): React.JSX.Element {
  const login = usePasswordLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return (
    <form
      className="signin-dev"
      onSubmit={(event) => {
        event.preventDefault();
        login.mutate({ email, password });
      }}
    >
      <input
        type="email"
        required
        autoComplete="username"
        aria-label="Email"
        placeholder="you@agency.com"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
      />
      <input
        type="password"
        required
        autoComplete="current-password"
        aria-label="Password"
        placeholder="Password"
        value={password}
        onChange={(event) => setPassword(event.target.value)}
      />
      <button className="button" type="submit" disabled={login.isPending}>
        Sign in
      </button>
      {login.isError && <p className="signin-error">{login.error.message}</p>}
      <p className="subtle">No password yet or forgotten? Ask Project A for a sign-in link.</p>
    </form>
  );
}
